var exports = {
  "kL": "xe564cbfb--874866--container",
  "iE": "xe564cbfb--874866--wrapper",
  "Hs": "xe564cbfb--874866--photo-block",
  "sf": "xe564cbfb--874866--main-content-block",
  "cn": "xe564cbfb--874866--photo-label",
  "UJ": "xe564cbfb--874866--content-container",
  "Dn": "xe564cbfb--874866--transports-container",
  "X": "xe564cbfb--874866--ad-info",
  "Eq": "xe564cbfb--874866--builder-name-wrapper",
  "RJ": "xe564cbfb--874866--description-wrapper",
  "Ie": "xe564cbfb--874866--empty",
  "PM": "xe564cbfb--874866--close-block",
  "Ht": "xe564cbfb--874866--mortgage-disclaimer",
  "VD": "xe564cbfb--874866--container--mortgage-annotations",
};

module.exports = exports;
